// extracted by mini-css-extract-plugin
export default {"sobreNos":"Sobre_sobreNos__BLFGp","sobreNos__texto":"Sobre_sobreNos__texto__2EbhG","imagens":"Sobre_imagens__Yrlym","imagens__imagem":"Sobre_imagens__imagem__HAUsp"};